/* Statuspunkt an den Oeffnungszeiten in der Fusszeile.

   Warum im Browser und nicht in Liquid: Shopify liefert Seiten aus dem
   Cache aus. Ein in Liquid gerechneter Zustand waere der Zustand zum
   Zeitpunkt des Renderns und koennte stundenlang falsch dastehen.

   Warum fest Europe/Berlin: Der Laden hat auf, wenn er in Berlin auf hat,
   nicht wenn es beim Besucher zehn Uhr ist.

   Zwei Einbauarten:

   - Fest (neue Fusszeile, tresen-fusszeile.liquid): der Traeger steht
     schon an der richtigen Stelle und traegt data-tresen-fest. Hier wird
     ihm nur das hidden abgenommen.
   - Verpflanzt (alte Theme-Fusszeile): deren Baustein ist ein
     Rich-Text-Feld und nimmt kein eigenes Markup an. Der Punkt kommt
     darum als fertiges Element von der Section und wird hier vor
     "Oeffnungszeiten:" gehaengt. Findet sich die Ueberschrift nicht,
     passiert nichts - der Punkt bleibt versteckt und die Fusszeile sieht
     aus wie vorher.

   Zwei regelmaessige Fenster: Gelb weist kurz vor der Oeffnung darauf
   hin, dass aufgesperrt wird. Gruen zeigt die regulaeren Oeffnungszeiten.
   Ausserhalb dieser Fenster bleibt der Punkt rot.

   Darueber liegen die Ausnahmen (Feiertag, Urlaub, heute spaeter auf).
*/
(function () {
  'use strict';

  var TAGE = { so: 0, mo: 1, di: 2, mi: 3, 'do': 4, fr: 5, sa: 6 };
  var KUERZEL = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };

  var FENSTER = [
    { zeiten: 'data-vor',   zustand: 'gleich', text: 'data-text-vor' },
    { zeiten: 'data-offen', zustand: 'offen',  text: 'data-text-offen' }
  ];

  /* "Mo-Fr 10:30-20:00; Sa 10:30-15:00" */
  function plan(text) {
    var eintraege = [];
    String(text || '').split(';').forEach(function (teil) {
      var m = teil.trim().match(/^([A-Za-zÄÖÜäöü]{2})\s*(?:[-–]\s*([A-Za-zÄÖÜäöü]{2}))?\s+(\d{1,2}):(\d{2})\s*[-–]\s*(\d{1,2}):(\d{2})$/);
      if (!m) return;

      var von = TAGE[m[1].toLowerCase()];
      var bis = m[2] ? TAGE[m[2].toLowerCase()] : von;
      if (von === undefined || bis === undefined) return;

      // Spannen duerfen ueber den Sonntag laufen (etwa Fr-Mo).
      var tage = [];
      for (var i = 0; i < 7; i++) {
        var t = (von + i) % 7;
        tage.push(t);
        if (t === bis) break;
      }

      eintraege.push({
        tage: tage,
        von: parseInt(m[3], 10) * 60 + parseInt(m[4], 10),
        bis: parseInt(m[5], 10) * 60 + parseInt(m[6], 10)
      });
    });
    return eintraege;
  }

  /* Eine Ausnahme je Zeile:
       2026-12-24 geschlossen
       2026-07-20 bis 2026-08-03 geschlossen
       2026-08-15 12:00-18:00
     Alles, was nicht als Uhrzeitspanne lesbar ist, gilt als geschlossen.
     Das ist die sichere Auslegung: ein Tippfehler macht den Laden zu,
     nicht faelschlich auf. */
  function ausnahmen(text) {
    var liste = [];
    String(text || '').split(/\r?\n/).forEach(function (zeile) {
      zeile = zeile.trim();
      if (!zeile || zeile.charAt(0) === '#') return;

      var m = zeile.match(/^(\d{4}-\d{2}-\d{2})(?:\s+bis\s+(\d{4}-\d{2}-\d{2}))?\s+(.+)$/i);
      if (!m) return;

      var eintrag = { von: m[1], bis: m[2] || m[1] };
      var zeit = m[3].trim().match(/^(\d{1,2}):(\d{2})\s*[-–]\s*(\d{1,2}):(\d{2})$/);

      if (zeit) {
        eintrag.vonMin = parseInt(zeit[1], 10) * 60 + parseInt(zeit[2], 10);
        eintrag.bisMin = parseInt(zeit[3], 10) * 60 + parseInt(zeit[4], 10);
        eintrag.vonText = zeit[1] + ':' + zeit[2];
        eintrag.bisText = zeit[3] + ':' + zeit[4];
      } else {
        eintrag.zu = true;
      }

      liste.push(eintrag);
    });
    return liste;
  }

  function jetztInBerlin() {
    var teile = {};
    new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Berlin',
      weekday: 'short',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hourCycle: 'h23'
    }).formatToParts(new Date()).forEach(function (p) { teile[p.type] = p.value; });

    return {
      tag: KUERZEL[teile.weekday],
      datum: teile.year + '-' + teile.month + '-' + teile.day,
      minute: parseInt(teile.hour, 10) * 60 + parseInt(teile.minute, 10)
    };
  }

  /* Nicht nur ob, sondern welches Fenster: der Wortlaut darf mit {bis}
     nach dem Ende des laufenden Fensters fragen ("bis 20 Uhr"). */
  function fenstertreffer(eintraege, nun) {
    for (var i = 0; i < eintraege.length; i++) {
      var e = eintraege[i];
      if (e.tage.indexOf(nun.tag) > -1 && nun.minute >= e.von && nun.minute < e.bis) return e;
    }
    return null;
  }

  /* Volle Stunden ohne ":00", das liest sich als "bis 20 Uhr". */
  function uhrzeit(minuten) {
    var stunde = Math.floor(minuten / 60);
    var minute = minuten % 60;
    return minute === 0 ? String(stunde) : stunde + ':' + (minute < 10 ? '0' + minute : minute);
  }

  function heutigeAusnahme(traeger, nun) {
    var liste = ausnahmen(traeger.getAttribute('data-ausnahmen'));
    for (var i = 0; i < liste.length; i++) {
      // ISO-Datumsangaben lassen sich als Zeichenketten vergleichen,
      // die Sortierung entspricht der zeitlichen Reihenfolge.
      if (nun.datum >= liste[i].von && nun.datum <= liste[i].bis) return liste[i];
    }
    return null;
  }

  function attr(el, name) { return el.getAttribute(name) || ''; }

  function setze(traeger) {
    var nun = jetztInBerlin();
    if (nun.tag === undefined) return;

    var zustand = 'zu';
    var text = attr(traeger, 'data-text-zu');
    var hinweis = '';
    var endet = null;

    var aus = heutigeAusnahme(traeger, nun);

    if (aus && aus.zu) {
      hinweis = attr(traeger, 'data-text-ausnahme-zu');

    } else if (aus) {
      var drin = nun.minute >= aus.vonMin && nun.minute < aus.bisMin;
      zustand = drin ? 'offen' : 'zu';
      text = attr(traeger, drin ? 'data-text-offen' : 'data-text-zu');
      if (drin) endet = aus.bisMin;
      hinweis = attr(traeger, 'data-text-ausnahme-zeit')
        .replace('{von}', aus.vonText)
        .replace('{bis}', aus.bisText);

    } else {
      for (var i = 0; i < FENSTER.length; i++) {
        var treffer = fenstertreffer(plan(attr(traeger, FENSTER[i].zeiten)), nun);
        if (treffer) {
          zustand = FENSTER[i].zustand;
          text = attr(traeger, FENSTER[i].text);
          endet = treffer.bis;
          break;
        }
      }
    }

    // Ohne laufendes Fenster gibt es keine Schlusszeit. Der Fall tritt
    // nur ein, wenn jemand {bis} in einen Wortlaut schreibt, der
    // ausserhalb aller Fenster gilt - dann faellt er still weg.
    text = endet === null
      ? text.replace(/\s*\{bis\}\s*/, ' ').trim()
      : text.replace('{bis}', uhrzeit(endet));

    traeger.setAttribute('data-zustand', zustand);

    // Das Wort "Oeffnungszeiten" traegt dieselbe Farbe wie der Punkt.
    // Es ist das Elternelement des Traegers, und aus einem Kind heraus
    // kann CSS keinen Vorfahren faerben - darum bekommt es den Zustand
    // hier als eigenes Attribut. Nur beim verpflanzten Einbau.
    if (traeger.zeitenKopf) {
      traeger.zeitenKopf.setAttribute('data-zeiten-zustand', zustand);
    }

    // Die Farbe allein traegt die Aussage nicht. Fuer Vorlesesoftware
    // steht der Zustand deshalb auch als Satz da.
    var sagt = traeger.querySelector('[data-tresen-zustandstext]');
    if (sagt) {
      var satz = hinweis === '' ? text : text + '. ' + hinweis;
      if (sagt.textContent !== satz) sagt.textContent = satz;
    }

    var zeile = traeger.zeitenAusnahmeZeile;
    if (zeile) {
      if (zeile.textContent !== hinweis) zeile.textContent = hinweis;
      zeile.hidden = hinweis === '';
    }
  }

  function einpflanzen(traeger) {
    // Fester Einbau: der Traeger steht schon, wo er hingehoert. Die
    // Ausnahmezeile liegt daneben statt darin - im Traeger waere sie ein
    // Flex-Element und stuende neben dem Punkt statt darunter.
    if (traeger.hasAttribute('data-tresen-fest')) {
      if (!traeger.zeitenAusnahmeZeile) {
        var umfeld = traeger.closest('[data-tresen-umfeld]') || traeger.parentElement;
        traeger.zeitenAusnahmeZeile = umfeld ? umfeld.querySelector('[data-tresen-ausnahme]') : null;
      }
      traeger.removeAttribute('hidden');
      return true;
    }

    if (!traeger.hasAttribute('hidden')) return true;

    var kopf = null;
    var kandidaten = document.querySelectorAll('footer strong, footer b');
    for (var i = 0; i < kandidaten.length; i++) {
      if (/^\s*öffnungszeit/i.test(kandidaten[i].textContent)) { kopf = kandidaten[i]; break; }
    }
    if (!kopf) return false;

    // Die Ausnahmezeile gehoert unter den Absatz, nicht in die fette
    // Ueberschrift - dort staende sie mitten in "Oeffnungszeiten:".
    // Nach dem Umhaengen liegt sie ausserhalb des Traegers, darum wird
    // sie hier gemerkt statt spaeter gesucht.
    var zeile = traeger.querySelector('[data-tresen-ausnahme]');
    var absatz = kopf.parentElement;
    if (zeile && absatz) {
      absatz.appendChild(zeile);
      traeger.zeitenAusnahmeZeile = zeile;
    }

    kopf.insertBefore(traeger, kopf.firstChild);
    traeger.removeAttribute('hidden');
    traeger.zeitenKopf = kopf;
    return true;
  }

  function alle() {
    document.querySelectorAll('[data-tresen-zeiten]').forEach(function (traeger) {
      if (einpflanzen(traeger)) setze(traeger);
    });
  }

  alle();
  // Einmal pro Minute reicht: feiner ist keine der Grenzen.
  setInterval(alle, 60000);
  // Nach dem Aufwachen aus einem Hintergrundtab sofort nachziehen.
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) alle();
  });
  // Im Theme-Editor nach jedem Neuladen einer Section.
  document.addEventListener('shopify:section:load', alle);
})();
